/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthTransactionsRouteImport } from './routes/_auth/transactions'
import { Route as AuthPlaid_accountsRouteImport } from './routes/_auth/plaid_accounts'
import { Route as AuthHomeRouteImport } from './routes/_auth/home'
import { Route as AuthBank_accountsRouteImport } from './routes/_auth/bank_accounts'
import { Route as AuthConnectIndexRouteImport } from './routes/_auth/connect/index'

const AboutLazyRouteImport = createFileRoute('/about')()
const AuthConnectPlaidLazyRouteImport = createFileRoute(
  '/_auth/connect/plaid',
)()
const AuthConnectMxLazyRouteImport = createFileRoute('/_auth/connect/mx')()

const AboutLazyRoute = AboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTransactionsRoute = AuthTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPlaid_accountsRoute = AuthPlaid_accountsRouteImport.update({
  id: '/plaid_accounts',
  path: '/plaid_accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBank_accountsRoute = AuthBank_accountsRouteImport.update({
  id: '/bank_accounts',
  path: '/bank_accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConnectIndexRoute = AuthConnectIndexRouteImport.update({
  id: '/connect/',
  path: '/connect/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConnectPlaidLazyRoute = AuthConnectPlaidLazyRouteImport.update({
  id: '/connect/plaid',
  path: '/connect/plaid',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/connect/plaid.lazy').then((d) => d.Route),
)
const AuthConnectMxLazyRoute = AuthConnectMxLazyRouteImport.update({
  id: '/connect/mx',
  path: '/connect/mx',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/connect/mx.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/about': typeof AboutLazyRoute
  '/bank_accounts': typeof AuthBank_accountsRoute
  '/home': typeof AuthHomeRoute
  '/plaid_accounts': typeof AuthPlaid_accountsRoute
  '/transactions': typeof AuthTransactionsRoute
  '/connect/mx': typeof AuthConnectMxLazyRoute
  '/connect/plaid': typeof AuthConnectPlaidLazyRoute
  '/connect/': typeof AuthConnectIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/about': typeof AboutLazyRoute
  '/bank_accounts': typeof AuthBank_accountsRoute
  '/home': typeof AuthHomeRoute
  '/plaid_accounts': typeof AuthPlaid_accountsRoute
  '/transactions': typeof AuthTransactionsRoute
  '/connect/mx': typeof AuthConnectMxLazyRoute
  '/connect/plaid': typeof AuthConnectPlaidLazyRoute
  '/connect': typeof AuthConnectIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/about': typeof AboutLazyRoute
  '/_auth/bank_accounts': typeof AuthBank_accountsRoute
  '/_auth/home': typeof AuthHomeRoute
  '/_auth/plaid_accounts': typeof AuthPlaid_accountsRoute
  '/_auth/transactions': typeof AuthTransactionsRoute
  '/_auth/connect/mx': typeof AuthConnectMxLazyRoute
  '/_auth/connect/plaid': typeof AuthConnectPlaidLazyRoute
  '/_auth/connect/': typeof AuthConnectIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/about'
    | '/bank_accounts'
    | '/home'
    | '/plaid_accounts'
    | '/transactions'
    | '/connect/mx'
    | '/connect/plaid'
    | '/connect/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/about'
    | '/bank_accounts'
    | '/home'
    | '/plaid_accounts'
    | '/transactions'
    | '/connect/mx'
    | '/connect/plaid'
    | '/connect'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/about'
    | '/_auth/bank_accounts'
    | '/_auth/home'
    | '/_auth/plaid_accounts'
    | '/_auth/transactions'
    | '/_auth/connect/mx'
    | '/_auth/connect/plaid'
    | '/_auth/connect/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  AboutLazyRoute: typeof AboutLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/transactions': {
      id: '/_auth/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthTransactionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/plaid_accounts': {
      id: '/_auth/plaid_accounts'
      path: '/plaid_accounts'
      fullPath: '/plaid_accounts'
      preLoaderRoute: typeof AuthPlaid_accountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank_accounts': {
      id: '/_auth/bank_accounts'
      path: '/bank_accounts'
      fullPath: '/bank_accounts'
      preLoaderRoute: typeof AuthBank_accountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/connect/': {
      id: '/_auth/connect/'
      path: '/connect'
      fullPath: '/connect/'
      preLoaderRoute: typeof AuthConnectIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/connect/plaid': {
      id: '/_auth/connect/plaid'
      path: '/connect/plaid'
      fullPath: '/connect/plaid'
      preLoaderRoute: typeof AuthConnectPlaidLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/connect/mx': {
      id: '/_auth/connect/mx'
      path: '/connect/mx'
      fullPath: '/connect/mx'
      preLoaderRoute: typeof AuthConnectMxLazyRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthBank_accountsRoute: typeof AuthBank_accountsRoute
  AuthHomeRoute: typeof AuthHomeRoute
  AuthPlaid_accountsRoute: typeof AuthPlaid_accountsRoute
  AuthTransactionsRoute: typeof AuthTransactionsRoute
  AuthConnectMxLazyRoute: typeof AuthConnectMxLazyRoute
  AuthConnectPlaidLazyRoute: typeof AuthConnectPlaidLazyRoute
  AuthConnectIndexRoute: typeof AuthConnectIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthBank_accountsRoute: AuthBank_accountsRoute,
  AuthHomeRoute: AuthHomeRoute,
  AuthPlaid_accountsRoute: AuthPlaid_accountsRoute,
  AuthTransactionsRoute: AuthTransactionsRoute,
  AuthConnectMxLazyRoute: AuthConnectMxLazyRoute,
  AuthConnectPlaidLazyRoute: AuthConnectPlaidLazyRoute,
  AuthConnectIndexRoute: AuthConnectIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  AboutLazyRoute: AboutLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
